<ppl-dialog title="Backup Codes"
            i18n-title="@@Backup_Codes"
            width="350px"
            actionLabel="Create new codes"
            i18n-actionLabel="@@Create_new_codes"
            [loading]="(loading$ | async) || (generating$ | async)"
            (action)="onCreateNewCodes()"
            (cancel)="onCancel()">
  <div class="content">
    <div class="title">
      <ng-container *ngIf="!(loading$ | async); else loadingEllipsis"
                    i18n="@@TwoFactorBackupCodesDialogRemainingCodes">
        {backupCodesRemainingCount$ | async, plural, =0 {No backup codes}
        =1 {1 backup code remaining}
        other {{{ backupCodesRemainingCount$ | async }} backup codes remaining}
        }</ng-container>
    </div>
    <div class="codes">
      <div *ngFor="let backupCodePair of (backupCodesByPairs$ | async)"
           class="backup-code-pair">
        <div *ngFor="let backupCode of backupCodePair"
             class="backup-code">
          <ng-container *ngIf="backupCode; else alreadyUsed">{{ backupCode }}</ng-container>
        </div>
      </div>
    </div>
  </div>
</ppl-dialog>

<ng-template #alreadyUsed>
  ... ...
</ng-template>

<ng-template #loadingEllipsis>
  ...
</ng-template>